import { URL } from "../../api/Api";
import { DYNAMIC_INTELLIGENCE } from "../Action";
import { catchError,GET,POST } from "../axios/Axios";

export const GetDynamicIntelligenceDetails = async (unique_id,email) => {
    try{
        const response = await GET(`${URL}/intake/dynamic-intelligence/access/${unique_id}/?email=${email}`)
        return response.data;
    } catch (error){
        throw catchError(error);
    }
}

export const DynamicIntelligenceChat = async (payload) => {
    try{
        const response =  await POST(`${URL}/chatbot/dynamic-intelligence/chat`, payload, {});
        return response.data;
    } catch (error){
        throw catchError(error);
    }
}

export const DynamicIntelligenceShare = async (payload, id) => {
    try {
      const response = await POST(`${URL}/intake/dynamic-intelligence/share`,payload, {});
      return response.data;
    } catch (error) {
      throw catchError(error);
    }
  };